<template>
  <el-card style="height: 100%" class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <el-row>
        <el-col :span="15">
          <span style="font-size: 24px">我的资料</span>
          <div class="head-text" style="float: right; margin-top: 0px">
            <!-- 新建事件 -->
            <el-input v-model="query" placeholder="请输入文件名称关键词" class="search-input" style="width: 300px"></el-input>
            <el-button @click="getDataFileList" slot="append" icon="el-icon-search"
              style="margin-right: 40px"></el-button>
          </div>
        </el-col>
        <el-col :span="9">
          <el-row>
            <el-col :span="4">
              <el-select filterable v-model="aaa.type" placeholder="请选择" @change="selectChange">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button @click="FileBatchDealOpen" style="width: 100%" type="primary"
                v-if="aaa.type === 0 || aaa.type === 2">批量报审</el-button> </el-col><el-col :span="4" :offset="1">
              <el-button style="width: 100%" @click="batchDownload" type="primary">批量下载</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button style="width: 100%" @click="MoveFile2('more')" type="primary">批量移动</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button style="width: 100%" type="danger" @click="deletefile">批量删除</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-container>
      <el-aside width="200px" style="
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          height: 100%;
          text-align: center;
        " class="elAside">
        <el-button type="primary" size="small" @click="showAll">{{ treeTypeAllCheck }}</el-button>
        <div class="zTreeDiv">
          <ul id="ProjectFileTree" class="ztree"></ul>
        </div>
        <div id="dataListRemenu" v-if="($store.state.permissions != null &&
          $store.state.permissions.includes('1041')) ||
          $store.state.isProject
          ">
          <ul>
            <li id="addDataList">新增资料</li>
          </ul>
        </div>
      </el-aside>
      <el-main>
        <div class="rygl-table">
          <el-table ref="multipleTable" :data="fileTableData" tooltip-effect="dark" style="width: 100%" max-height="620"
            @selection-change="fileFlowhandleSelectionChange" v-loading="tableLoading">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" type="index" label="序号"></el-table-column>
            <el-table-column align="center" width="200px" prop="name" label="文件名称" sortable>
              <template slot-scope="scope">
                <a v-if="exts.indexOf(scope.row.ext) > -1" style="cursor: pointer;" target="_blank"
                  @click="documentOpen(scope.row)">
                  <!-- <el-button style="width: 100%" :title="scope.row.prfl02"> -->
                  {{
                    // scope.row.prfl02.length > 10
                    // ? scope.row.prfl02.substr(0, 10) + "..."
                    // :
                    scope.row.prfl02
                  }}
                  <!-- </el-button> -->
                </a>
                <span v-else>{{ scope.row.prfl02 }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="prfl09" label="大小（MB）"></el-table-column>
            <el-table-column align="center" prop="user04" label="上传用户"></el-table-column>
            <el-table-column align="center" prop="prfl12" label="上传时间"></el-table-column>
            <el-table-column align="center" prop="prfl13" label="状态">
              <template slot-scope="scope">
                <span @click="FindBHMsgOpen(scope.row)" :style="{
                  color: scope.row.prfl13 == 2 ? 'red' : '',
                  cursor: scope.row.prfl13 == 2 ? 'pointer' : 'default',
                }">{{
  scope.row.prfl13 == 0
  ? "未提交审核"
  : scope.row.prfl13 == 1
    ? "审核中"
    : scope.row.prfl13 == 2
      ? "审核未通过"
      : "审核已通过"
}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="操作" width="280">
              <template slot-scope="scope">
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="updataSee(scope.row.prfl01)">修改</el-button>
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="download(scope.row)">下载</el-button>
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="MoveFile2('singer', scope.row)">移动</el-button>
                <el-button size="small" plain type="danger" style="cursor: pointer"
                  @click="deletefile('singer', scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination style="margin-top: 20px" align="center" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[10, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-main>
    </el-container>

    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" title="新增资料" :visible.sync="dialogVisible" width="40%">
      <el-row>
        <el-col :span="12">
          <el-upload class="upload-demo" ref="upload" :action="actionUrl" :before-upload="handleBefore"
            :file-list="fileList" :auto-upload="false" :data="aaa" multiple="" :headers="importHeaders"
            :on-success="handleSuccess">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">上传文件不超过500M</div>
          </el-upload>
        </el-col>
        <el-col :span="12">
          可见设置：
          <el-radio v-model="radio" :label="1">公开</el-radio>
          <el-radio v-model="radio" :label="2">半公开</el-radio>
          <div style="
              border: 2px solid #eee;
              height: 200px;
              max-height: 200px;
              overflow: auto;
              width: 80%;
              box-sizing: border-box;
            " v-if="radio == 2">
            <el-row style="padding: 10px">
              <el-col :span="8" v-for="(item, index) in multipleSelection2" :key="index" style="padding-top: 10px">
                <el-row style="padding: 0px">
                  <el-col :span="20">{{ item.user04 }}</el-col>
                  <el-col :span="4">
                    <span style="color: red; cursor: pointer" @click="delectUser(index)">x</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-button type="primary" size="small" style="margin: 10px" v-if="radio == 2"
            @click="dialogVisible1OPen">添加</el-button>
        </el-col>
      </el-row>
      <el-row style="height: 80px">
        <el-col :span="3" :offset="8">
          <el-button type="primary" style="width: 100%" @click="submitUpload">上传</el-button>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button type="primary" style="width: 100%" @click="dialogVisible = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 项目下的人员列表 -->
    <el-dialog :close-on-click-modal="false" title="请选择人员" :visible.sync="dialogVisible1" width="25%">
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input v-model="selectName" placeholder="请输入名称" class="search-input" style="width: 85%"></el-input>
        <el-button @click="dialogVisible1OPen" slot="append" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%" max-height="400"
        @selection-change="handleSelectionChange2">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div style="width: 100%; height: 40px; margin-top: 10px; text-align: center">
        <el-button type="primary" size="small" @click="dialogVisible1 = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 请选择人员 -->
    <el-dialog :close-on-click-modal="false" title="请选择人员" :visible.sync="dialogVisible5" width="25%">
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input v-model="selectName2" placeholder="请输入名称" class="search-input" style="width: 85%"></el-input>
        <el-button @click="dialogVisible5OPen" slot="append" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData4" tooltip-effect="dark" style="width: 100%" max-height="400"
        @selection-change="handleSelectionChange3">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <el-row style="height: 80px; text-align: center">
        <el-button type="primary" @click="dialogVisible5True">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 修改可见 -->
    <el-dialog :close-on-click-modal="false" title="修改可见" :visible.sync="dialogVisible4" width="40%">
      <div>
        可见设置：
        <el-radio @change="radioChang" v-model="radio3" :label="1">公开</el-radio>
        <el-radio @change="radioChang" v-model="radio3" :label="2">半公开</el-radio>
        <div style="
            border: 2px solid #eee;
            height: 200px;
            overflow: auto;
            width: 80%;
            margin: 10px;
            box-sizing: border-box;
          " v-if="radio3 == 2">
          <el-row>
            <el-col :span="6" v-for="(item, index) in multipleSelection3" :key="index">
              <el-row>
                <el-col :span="20">{{ item.user04 }}</el-col>
                <el-col :span="4">
                  <span style="color: red; cursor: pointer" @click="delectUser2(item.user01)">x</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <el-button type="primary" v-if="radio3 == 2" style="margin: 10px" @click="dialogVisible5OPen">添加</el-button>
      </div>
    </el-dialog>
    <!-- 移动 -->
    <el-dialog :close-on-click-modal="false" title="移动分组" :visible.sync="dialogVisible6" width="40%">
      <el-card class="box-cord">
        <el-table ref="singleTable" :data="TreeData" highlight-current-row @current-change="handleCurrentChange2"
          style="width: 100%; margin-bottom: 20px" default-expand-all row-key="pftr01" border :tree-props="{
            children: 'children',
            hasChildren: 'hasChildren',
          }">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="pftr02" label="名称"></el-table-column>
        </el-table>
        <el-row>
          <el-col :span="6" :offset="6">
            <el-button type="primary" @click="MoveFileTrue">确定</el-button>
          </el-col>
          <el-col :span="6">
            <el-button type="danger" @click="dialogVisible6 = false">取消</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
    <!-- 资料预览 -->
    <el-dialog :close-on-click-modal="false" width="80%" :visible.sync="documentIsShow">
      <div slot="title" style="height: 25px;
        line-height: 25px;">
        <span style="font-size:20px">资料预览</span>
        <span style="float: right;
          margin-right: 22px;cursor: pointer;">
          <i @click="dianji" class="el-icon-copy-document"></i>
        </span>
      </div>
      <div>
        <iframe width="100%" height="650px" allow="fullscreen" id="iframeId" frameborder="0" scrolling="auto"
          :src="iframeUrl"></iframe>
      </div>
    </el-dialog>
    <!-- 报审 -->
    <el-drawer title="资料报审" :visible.sync="fileFlowDrawer" direction="rtl" size="50%">
      <el-button size="mini" type="primary" @click="myselfFileFlowOpen">管理个人审核模块</el-button>
      <el-button size="mini" type="primary" @click="FileBatchDeal">确认并提交审核</el-button>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="6">选择审批模块：</el-col>
        <el-col :span="18">
          <el-cascader placeholder="试试搜索" :options="examineAndApprove" filterable
            @change="selectExamineAndApprove"></el-cascader>
        </el-col>
      </el-row>
      <!-- 这里是单个流程的审批详情 -->
      <el-table :data="oneFileFlow" style="width: 100%">
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="name" label="流程节点">
          <template slot-scope="scope">
            <el-input disabled v-model="scope.row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="审批人">
          <template slot-scope="scope">
            <el-select disabled filterable v-model="scope.row.users" multiple>
              <el-option :label="item.user04" :title="item.user02" :value="item.user01" v-for="item in userList"
                :key="item.user01"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="审批性质">
          <template slot-scope="scope">
            <el-select disabled v-model="scope.row.type" placeholder="请选择">
              <el-option v-for="item in examineType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <!-- 个人报审模块 -->
    <el-drawer title="个人预定义审核流程模板管理" :visible.sync="myselfFileFlow" direction="rtl" size="40%">
      <el-button type="danger" size="medium" style="float: right; margin-right: 10px" class="float-r-mar-r10"
        @click="DelFileWorkFlow('more')">批量删除</el-button>
      <el-button type="primary" size="medium" style="float: right; margin-right: 10px" class="float-r-mar-r10"
        @click="addActionFlow">新建</el-button>
      <el-table @selection-change="handleSelectionChange" v-loading="loading" :data="tableData" style="width: 100%">
        <el-table-column type="selection"> </el-table-column>
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="pfwf03" label="名称"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="updateFlow(scope.row)" type="primary" size="mini">修改</el-button>
            <el-button @click="CopyFileWorkFlow(scope.row)" type="primary" size="mini">复制</el-button>
            <el-button type="danger" size="mini" @click="DelFileWorkFlow('single', scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <!-- 增加，修改资料审核流程 -->
    <el-drawer title="流程环节详情" :visible.sync="addActionFlowVisible" direction="rtl" size="35%">
      <el-form ref="form" :model="model" label-width="80px">
        <el-form-item label="审核名称">
          <el-input v-model="model.model.pfwf03"></el-input>
        </el-form-item>
        <i @click="addFlowDom()" class="el-icon-circle-plus-outline" style="
            font-size: 30px;
            color: green;
            float: right;
            margin-right: 20px;
          "></i>
        <el-table :data="model.list" style="width: 100%">
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column prop="name" label="流程节点">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="审批人">
            <template slot-scope="scope">
              <el-select filterable v-model="scope.row.users" @change="changeUser" multiple @remove-tag="removetag">
                <el-option :label="item.user04" :title="item.user02" :value="item.user01" v-for="item in userList"
                  :key="item.user01" v-show="item.isSelect === false"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="审批性质">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option v-for="item in examineType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i @click="addFlowDom(scope)" class="el-icon-circle-plus-outline" style="font-size: 30px; color: green"></i>
              <i @click="deleteFlowDom(scope)" class="el-icon-remove-outline" style="font-size: 30px; color: red"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button type="primary" @click="AddFileWorkFlow">{{
            this.type == "add" ? "立即创建" : "修改"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!-- 驳回信息 -->
    <el-dialog :close-on-click-modal="false" title="驳回信息" width="20%" :visible.sync="FindBHMsg">
      <el-form label-width="80px">
        <el-form-item label="姓名"> {{ BHList.name }}</el-form-item>
        <el-form-item label="时间"> {{ BHList.time }}</el-form-item>
        <el-form-item label="内容">
          <el-input disabled type="textarea" v-model="BHList.Msg"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import dataManagement from "@/mixin/dataManagement";
import * as tools from "@/tools/tool";
import {
  GetProjectFileZTree,
  GetMyUploadFile,
  DelDataFile,
  MoveFile,
  GetFileWhitOutUserList,
  GetFileWhitUserList,
  DelFileWhitUser,
  AddFileUser,
  ChangeFileState,
  Office2Pdf,
  FileBatchDeal,
  GetFileWorkFlow,
  FindFileWorkFlow,
  GetProUsersList,
  FindBHMsg,
} from "@/setAxios.js";
export default {
  name: "dataList",
  mixins: [dataManagement],
  data() {
    return {
      fileFlowDrawer: false,
      myselfFileFlow: false,
      fileFlowId: "",
      oneFileFlow: [],
      examineAndApprove: [],
      fileMultipleSelection: [],
      FindBHMsg: false,
      BHList: {},
      exts: [
        "png",
        "jpg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "js",
        "txt",
        "gif",
        "pdf",
      ],
      actionUrl: this.$store.state.baseUrl + "/api/UploadDataFile",
      currentRow: null,
      fid: "",
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      query: "",
      radio: 1,
      radio3: 1,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      value: "",
      selectName: "",
      selectName2: "",
      TreeData: [],
      fileTableData: [],
      tableLoading: false,
      tableData3: [],
      tableData4: [],
      multipleSelection2: [],
      multipleSelection3: [],
      multipleSelection4: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: "",
        ids: "null",
        qid: localStorage.getItem("pid"),
      },
      documentIsShow: false,
      iframeUrl: "",
      typeOptions: [
        { value: "", label: "全部" },
        { value: 1, label: "审核中" },
        { value: 0, label: "未提交审核" },
        { value: 3, label: "审核通过" },
        { value: 2, label: "审核未通过" },
      ],
      treeTypeAllCheck: "显示全部",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    dianji() {
      //设置后就是id==con_lf_top_div 的容器全屏
      let case1 = document.getElementById("iframeId");
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (case1.requestFullscreen) {
          case1.requestFullscreen();
        } else if (case1.webkitRequestFullScreen) {
          case1.webkitRequestFullScreen();
        } else if (case1.mozRequestFullScreen) {
          case1.mozRequestFullScreen();
        } else if (case1.msRequestFullscreen) {
          // IE11
          case1.msRequestFullscreen();
        }
      }
    },
    async FindBHMsgOpen(data) {
      if (data.prfl13 == 2) {
        let res = await FindBHMsg({ params: { id: data.prfl01 } });
        this.BHList = res.Data;
        this.FindBHMsg = true;
      }
    },
    // 批量下载
    batchDownload() {
      if (this.baseNotity()) {
        return;
      }
      this.fileMultipleSelection.forEach((ele) => {
        this.download(ele);
      });
    },
    baseNotity() {
      if (this.fileMultipleSelection.length == 0) {
        this.$message({
          message: "请选勾选报审资料",
          type: "warning",
        });
        return true;
      }
    },
    // 打开批量报审
    async FileBatchDealOpen() {
      if (this.baseNotity()) {
        return;
      }
      this.fileFlowDrawer = true;
      // 获取公共的
      var params = {
        xid: localStorage.xid,
        uid: localStorage.id,
        type: 0,
      };
      var res = await GetFileWorkFlow({ params });
      var publicData = res.Data;
      publicData.forEach((ele) => {
        (ele.value = ele.pfwf01), (ele.label = ele.pfwf03);
      });
      // 获取私人的
      params = {
        xid: localStorage.xid,
        uid: localStorage.id,
        type: 1,
      };
      res = await GetFileWorkFlow({ params });
      var privateData = res.Data;
      privateData.forEach((ele) => {
        (ele.value = ele.pfwf01), (ele.label = ele.pfwf03);
      });
      this.examineAndApprove = [
        {
          value: "public",
          label: "项目预定义模版",
          children: publicData,
        },
        {
          value: "private",
          label: "个人模版",
          children: privateData,
        },
      ];
      var params = {
        seachword: "",
        id: localStorage.xid,
        cid: localStorage.pid,
        bid: "null",
        pageIndex: 1,
        pageSize: 10000,
      };
      var res = await GetProUsersList({ params });
      this.userList = res.Data.list;
    },
    // 批量报审
    async FileBatchDeal() {
      let ids = [];
      this.fileMultipleSelection.forEach((ele) => {
        ids.push(ele.prfl01);
      });
      if (this.fileFlowId) {
        let params = { ids, id: this.fileFlowId, type: "report" };
        let res = await FileBatchDeal(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: "提交报审成功",
          });
        }
        this.fileFlowDrawer = false;
        this.getDataFileList();
      } else {
        this.$message({
          type: "warning",
          message: "请先选择模版",
        });
      }
    },
    // 个人报审模块
    myselfFileFlowOpen() {
      this.myselfFileFlow = true;
      // 判断是通用的还是个人的  通用下面两个值为0，个人为1
      this.model.model.pfwf05 = 1;
      this.globalType = 1;
      this.GetFileWorkFlow();
    },
    // 获取单个模版下的流程
    async selectExamineAndApprove(data) {
      let id = data[data.length - 1];
      this.fileFlowId = id;
      var params = { id };
      var res = await FindFileWorkFlow({ params });
      this.oneFileFlow = res.Data.list;
      this.oneFileFlow.forEach((ele) => {
        ele.users = ele.users.split(",").map(Number);
      });
    },
    async documentOpen(item) {
      this.documentIsShow = true;
      if (
        item.ext == "pdf" ||
        item.ext == "png" ||
        item.ext == "jpg" ||
        item.ext == "mp4" ||
        item.ext == "gif" ||
        item.ext == "txt"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + item.prfl04;
      } else {
        let res = await Office2Pdf({ sourcePath: item.prfl04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
    },
    //下载
    download(data) {
      tools.download(data.prfl07, data.prfl02);
    },
    // 移动
    MoveFile2(type, data) {
      if (type == "singer") {
        this.fileMultipleSelection.push(data);
      }
      if (this.fileMultipleSelection.length > 0) {
        this.dialogVisible6 = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先做选择",
        });
      }
    },
    MoveFileTrue() {
      let fids = [];
      this.fileMultipleSelection.forEach((ele) => {
        fids.push(ele.prfl01);
      });
      fids = fids.join(",");
      let params = {
        fid: fids,
        gid: this.currentRow.pftr01,
      };
      this.$confirm("是否移动该资料?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        MoveFile(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "移动成功",
            });
            this.dialogVisible6 = false;
            this.getData();
          }
        });
      });
    },
    radioChang(data) {
      let params = {
        fid: this.fid,
        type: data,
      };
      ChangeFileState({ ...params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "更改成功",
          });
        }
      });
    },
    dialogVisible5True() {
      let uids = [];
      this.multipleSelection4.forEach((ele) => {
        uids.push(ele.user01);
      });
      let params = {
        uids: uids.join(","),
        fid: this.fid,
      };
      AddFileUser({ ...params }).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.dialogVisible4 = false;
          this.dialogVisible5 = false;
        }
      });
    },
    updataSee(fid) {
      this.dialogVisible4 = true;
      this.fid = fid;
      let params = {
        fid: fid,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitUserList({ params }).then((res) => {
        this.multipleSelection3 = res.Data.list;
        this.radio3 = res.Data.type;
        //(res, "参加过的");
      });
    },
    // 删除
    deletefile(type, data) {
      let fids = [];
      if (type !== "singer") {
        if (this.baseNotity()) {
          return;
        }
        this.fileMultipleSelection.forEach((ele) => {
          fids.push(ele.prfl01);
        });
        fids = fids.join(",");
      } else {
        fids = data.prfl01;
      }
      //(fids);
      this.$confirm("是否删除该资料?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelDataFile({ fids }).then((res) => {
            //(res);
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              this.$message({
                type: "warning",
                message: "删除失败",
              });
            }
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.dialogVisible = false;
        this.aaa.type = "";
        this.getData();
      }
    },
    delectUser(index) {
      //(index);

      this.multipleSelection2.splice(index, 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    delectUser2(id) {
      let params = {
        uid: id,
        fid: this.fid,
      };
      DelFileWhitUser({ ...params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.updataSee(this.fid);
        }
      });
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      let params = {
        searchword: this.selectName,
        fid: 0,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitOutUserList({ params }).then((res) => {
        this.tableData3 = res.Data.list;
      });
    },
    dialogVisible5OPen() {
      this.dialogVisible5 = true;
      let params = {
        searchword: this.selectName2,
        fid: this.fid,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitOutUserList({ params }).then((res) => {
        this.tableData4 = res.Data.list;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleBefore(file) {
      if (file.size / 1024 / 1024 > 500) {
        this.$message.error("不能超过500M");
        return false;
      }
      let fd = new FormData();
      this.aaa.type = this.radio;
      let userID = [];
      this.multipleSelection2.forEach((ele) => {
        userID.push(ele.user01);
      });
      this.aaa.Uids = userID.join(",");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    // 初始化数据
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
      });
    },
    // 获取我的文件
    getDataFileList() {
      let params = {
        searchword: this.query,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        gid: this.aaa.ids,
        type: this.aaa.type,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      this.tableLoading = true;
      GetMyUploadFile({ params }).then((res) => {
        this.tableLoading = false;
        this.total = res.Data.total;
        this.fileTableData = res.Data.list;
        if (this.fileTableData) {
          this.fileTableData.forEach((v) => {
            v.ext = v.prfl03
              .substring(v.prfl03.lastIndexOf(".") + 1)
              .toLowerCase();
          });
        }
      });
    },
    selectChange(data) {
      this.aaa.type = data;
      this.getDataFileList();
    },
    // 显示全部
    showAll() {
      if (this.treeTypeAllCheck === '显示全部') {
        this.zTeeObj.checkAllNodes(true);
        this.aaa.ids = "null";
        this.treeTypeAllCheck = '取消显示全部'
      } else {
        this.zTeeObj.checkAllNodes(false);
        this.aaa.ids = "";
        this.treeTypeAllCheck = '显示全部'
      }
      this.getDataFileList();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
          onRightClick: OnRightClick,
        },
      };
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          _this.aaa.gid = treeNode.pftr01;
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "dataListRemenu" ||
            $(event.target).parents("#dataListRemenu").length > 0
          )
        ) {
          $("#dataListRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type != "root") {
          $("#dataListRemenu").show();
          $("#addDataList").show();
          $("#dataListRemenu").css({
            top: y + "px",
            left: x + "px",
            visibility: "visible",
          }); //设置右键菜单的位置、可见
          $("body").bind("mousedown", onBodyMouseDown);
        }
      }

      $("#dataListRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#dataListRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDataList") {
            _this.aaa.type = 1;
            _this.dialogVisible = true;
          }
        });

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.zTeeObj.checkAllNodes(false);
      this.zTeeObj.expandAll(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.aaa.ids = "null";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.aaa.ids += _split + element.pftr01;
        _split = ",";
      });
      _this.getDataFileList();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.aaa.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.aaa.ids += _split + element.pftr01;
          _split = ",";
        });
        _this.getDataFileList();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.aaa.ids = treeNode.pftr01;
        _this.getDataFileList();
      }
    },
    fileFlowhandleSelectionChange(val) {
      this.fileMultipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    handleSelectionChange3(val) {
      this.multipleSelection4 = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDataFileList();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getDataFileList();
    },
    handleCurrentChange2(val) {
      this.currentRow = val;
    },
  },
};
</script>

<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#ProjectFileTree {
  height: 640px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}

.userManagement .search-input {
  width: 300px;
}
</style>
